// extracted by mini-css-extract-plugin
export default {"spinner":"SubmitButton_spinner__M63wI","submitButtonDisabled":"SubmitButton_submitButtonDisabled__rSNEY","submitButtonSubmitting":"SubmitButton_submitButtonSubmitting__4zer8"};